import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
// import { getWaitScrutinize } from '../../redux/actions/multiReview'
import { startLoading, doneLoading } from '../../utils/loading'
import ReviewerWithdrawReviewDataTable from '../dataTable/ReviewerWithdrawReviewDataTable'
import {
  getProjectPaymentReview,
  getProjectPaymentReviewByStatus,
  getProjectPaymentReviewApprove,
  getProjectPaymentReviewApproveByStatus,
  downloadPayment,
  searchByReviewer,
  searchByReviewerForApprover,
  searchReviewerPaymentByReviewer,
  downloadPaymentEForm,
} from '../../redux/actions/withdrawReviewPayment'
import { downloadFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'

export default function ReviewerWaitForWithdrawTableWidget({
  schema: _schema,
  onSelectedRowData,
  isApproveTable,
  onShow,
  onChangeShow,
  statusOptions,
  statusOptionsForApprover,
  ...props
}) {
  const [loading, setloading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState(_schema)
  const [isLoading, setIsLoading] = useState(false)
  let history = useHistory()

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let request = {
        firstName: '',
        lastName: '',
        idCard: '',
        pageSize: 5,
        pageNumber: 1,
        status: isApproveTable ? 2 : 1,
      }
      let response
      if (isApproveTable) {
        response = await searchReviewerPaymentByReviewer(request)
      } else {
        response = await searchReviewerPaymentByReviewer(request)
      }
      setSchema(response.model)
      //setSchema(mockSchema.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSearchReviewer = async (
    pagesize,
    pagenumber,
    firstName,
    lastName,
    idCard,
    status
  ) => {
    startLoading()
    setloading(true)
    try {
      let request = {
        firstName: firstName,
        lastName: lastName,
        idCard: idCard,
        pageSize: pagesize,
        pageNumber: pagenumber,
        status: status,
      }
      let response
      if (isApproveTable) {
        response = await searchReviewerPaymentByReviewer(request)
      } else {
        response = await searchReviewerPaymentByReviewer(request)
      }
      if (response) {
        setSchema(response.model)
      }
      // setSchema(mockSchemaSearch)
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handleOnReLoad = async (pagesize, pagenumber, firstName, lastName, idCard, status) => {
    console.log('handleOnReLoad => ', pagesize, pagenumber)
    startLoading()
    setloading(true)
    try {
      let request = {
        firstName: firstName,
        lastName: lastName,
        idCard: idCard,
        pageSize: pagesize,
        pageNumber: pagenumber,
        status: status,
      }
      // if (status === 'all') {
      //   let response
      //   if (isApproveTable) {
      //     response = await searchReviewerPaymentByReviewer(request)
      //   } else {
      //     response = await searchReviewerPaymentByReviewer(request)
      //   }
      //   setSchema(response.model)
      // } else {
      let response
      if (isApproveTable) {
        response = await searchReviewerPaymentByReviewer(request)
      } else {
        response = await searchReviewerPaymentByReviewer(request)
      }
      setSchema(response.model)
      //}
      //setSchema(mockSchema.model)
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handleSearchStatus = async (pagesize, pagenumber, status) => {
    console.log('handleSearchStatus => ', pagesize, pagenumber, status)
    startLoading()
    setloading(true)
    try {
      // if (status === 'all') {
      //   let response
      //   if (isApproveTable) {
      //     response = await getProjectPaymentReviewApprove(pagesize, pagenumber)
      //   } else {
      //     response = await getProjectPaymentReview(pagesize, pagenumber)
      //   }
      //   setSchema(response.model)
      // } else {
      //   let response
      //   if (isApproveTable) {
      //     response = await getProjectPaymentReviewApproveByStatus(pagesize, pagenumber, status)
      //   } else {
      //     response = await getProjectPaymentReviewByStatus(pagesize, pagenumber, status)
      //   }
      //   setSchema(response.model)
      // }
      //setSchema(mockSchema.model)
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const onShowDetail = (rowData, status) => {
    if (rowData) {
      onSelectedRowData(rowData, status)
    }
  }

  const onDownload = async (rowData) => {
    console.log('rowData', rowData)
    startLoading()
    try {
      const file = await downloadPaymentEForm(rowData.id)
      let fileName = 'ใบเบิกจ่าย ' + rowData.firstName + rowData.lastName
      downloadFile(file, fileName)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  return (
    <>
      {schema && (
        <ReviewerWithdrawReviewDataTable
          schema={schema}
          pagination={true}
          onReload={handleOnReLoad}
          onSearchStatus={handleSearchStatus}
          loading={loading}
          onDownload={onDownload}
          onShowDetail={onShowDetail}
          onShow={onShow}
          onChangeShow={onChangeShow}
          onSearchReviewer={handleSearchReviewer}
          isApproveTable={isApproveTable}
          statusOptions={statusOptions}
          statusOptionsForApprover={statusOptionsForApprover}
        />
      )}
    </>
  )
}
